import { Component, ChangeDetectionStrategy, input } from '@angular/core';

import { Message } from 'src/config/constants';

import { EntFormWidgetsModule } from '@ng/ent-components/ent-form-widgets';

@Component({
    selector: 'app-case-tracker',
    templateUrl: './case-tracker.component.html',
    styleUrls: ['./case-tracker.component.scss'],
    imports: [EntFormWidgetsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CaseTrackerComponent {

  /** Indicates that a letter of authorization is unavailable. */
  readonly noLOA = input(false);

  /** Selects the case or REG60 heading and presentation. */
  readonly trackerType = input<'case' | 'reg60'>('case');

  message = Message;

}
